export const YEARREGEX = new RegExp(/^(19|20)\d\d$/);
export const VINDIGITS = new RegExp(/[A-HJ-NPR-Za-hj-npr-z\d]/);
export const VINREGEX = new RegExp(/[A-HJ-NPR-Z0-9]{17}/);
export const PHONEREGEX = new RegExp(/^(\d{0,2})(\d{3})(\d{3})(\d{4})$/);
